<script setup>
definePageMeta({
    ignoreOnBoarding: true
})

// Track Page Load
trackPageLoad({
    title: TRACKING_CONSTANTS.TITLES.FAQ_PAGE,
})
</script>

<template>
    <PageMainContainer :page-main-container-config="{ appFooter: true }">
        <FaqContent />
    </PageMainContainer>
</template>
